// AUTO-GENERATED from src/study/content/canonical/* — do not edit by hand.
// Regenerate with scripts/gen_content_js.py. Byte-identical to the spec's canonical blocks.

export const A1_STARTER = `import trio

async def timer() -> None:
    """Prints the number of seconds that have passed starting at '1s' """
    raise NotImplementedError("timer")

async def delayed_hello() -> None:
    """Sleeps for 2.1 seconds and the prints 'Hello, World!' """
    raise NotImplementedError("delayed_hello")

async def task1():
    """
    In this task, you will use the trio library to write two async functions.
    Your task is to complete the timer and delayed_hello functions.
    """
    print("Starting...")
    TIMEOUT = 2.5
    with trio.move_on_after(TIMEOUT):
        # TODO: start trio nursery
        # TODO: start timer function
        # TODO: start delayed_hello
        pass
    print("Completed!")
    return
`

export const B1_STARTER = `import trio

# PROVIDED - do not modify.
async def get_user_id(user_id: int) -> str:
    await trio.sleep(1)
    if user_id % 2 == 0:
        return f"User-{user_id}"
    else:
        raise ValueError(f"User {user_id} not found")


async def get_user_data(user_ids: list[int]) -> dict[str]:
    """
    Asynchronously fetch user_ids using get_user_id. Store the result as 'error' if
    an error is encountered.
    """
    raise NotImplementedError("Implement get_user_data")


async def task2():
    """
    In this task, you will implement error handling. In this test case, we create a
    list of 5 user IDs (mix of even and odd numbers). We call get_user_data() with this list.
    """
    user_ids = [1, 2, 3, 4, 5]
    results = await get_user_data(user_ids)
    print("Results:")
    for user_id, result in results.items():
        print(f"User {user_id}: {result}")
`

export const A2_STARTER = `import trio

############## PROVIDED - DO NOT MODIFY ##############
async def load_config() -> None:
    """Loads configuration. Provided - do not modify."""
    print("Loading config")
    await trio.sleep(0.5)
    print("Config loaded")

async def worker(n: int) -> None:
    """Worker n does its job. Provided - do not modify."""
    print(f"Worker {n} starting")
    await trio.sleep(n * 0.5)
    print(f"Worker {n} done")
############## END PROVIDED ##########################


async def heartbeat() -> None:
    """Prints 'tick' every 0.4 seconds (first tick after 0.4s), forever."""
    raise NotImplementedError("heartbeat")


async def task_a2():
    """Orchestrate startup:
    1. Print 'Booting...'
    2. Configuration completes fully before anything else starts.
    3. Workers 1 and 2 run at the same time, heartbeat ticking alongside.
    4. The worker phase is capped at 1.3 seconds; the heartbeat stops with it.
    5. Print 'Shutdown complete' last.
    """
    raise NotImplementedError("task_a2")


if __name__ == "__main__":
    trio.run(task_a2)
`

export const B2_STARTER = `import trio

############## PROVIDED - DO NOT MODIFY ##############
class TransientError(Exception):
    """A temporary glitch (e.g., a timeout). Retrying once usually resolves it."""

class PermanentError(Exception):
    """The record is corrupted. Retrying never helps."""

_attempts = {}

async def fetch_record(record_id: int) -> str:
    """Fetch one record. Takes 0.3s per attempt.
    Raises TransientError or PermanentError as described in the instructions."""
    await trio.sleep(0.3)
    n = _attempts.get(record_id, 0) + 1
    _attempts[record_id] = n
    if record_id % 3 == 0:
        raise PermanentError(f"Record {record_id} is corrupted")
    if record_id % 3 == 1 and n == 1:
        raise TransientError(f"Record {record_id} timed out")
    return f"Record-{record_id}"
############## END PROVIDED ##########################


async def get_records(record_ids: list[int]) -> dict[int, str]:
    """Fetch all records concurrently. TransientError -> retry once;
    PermanentError -> 'error' immediately. See instructions for details."""
    raise NotImplementedError("get_records")


async def task_b2():
    record_ids = [1, 2, 3, 4, 5, 6]
    results = await get_records(record_ids)
    print("Results:")
    for record_id, result in results.items():
        print(f"Record {record_id}: {result}")


if __name__ == "__main__":
    trio.run(task_b2)
`

export const WARMUP_STARTER = `"""Warm-up: Event Log Summarizer  (15 minutes - no AI, no outside resources)

Work top to bottom. It's fine not to finish; do as much as you can.
Run this file at any point:  python warmup_starter.py
Expected values are printed next to each check at the bottom.
"""

events = [
    {"user": "ana",  "type": "login",  "ts": 100},
    {"user": "ben",  "type": "login",  "ts": 105},
    {"user": "ana",  "type": "edit",   "ts": 130},
    {"user": "cara", "type": "login",  "ts": 160},
    {"user": "ben",  "type": "logout", "ts": 240},
    {"user": "cara", "type": "edit",   "ts": 250},
    {"user": "dev",  "type": "login",  "ts": 260},
    "corrupted-row-#17",
    {"user": "ana",  "type": "logout", "ts": 300},
    {"user": "dev",  "type": "edit",   "ts": 310},
    {"user": "cara", "type": "logout", "ts": 350},
]


def count_by_type(events):
    """Return a dict mapping event type -> count. Ignore corrupted entries."""
    raise NotImplementedError("count_by_type")


def events_in_window(events, start, end):
    """Return the list of events with start <= ts < end. Ignore corrupted entries."""
    raise NotImplementedError("events_in_window")


def top_user(events):
    """Return the user with the most events. Ties -> alphabetically first user."""
    raise NotImplementedError("top_user")


def safe_get_user(event):
    """Return the event's user, or None if the entry is corrupted
    (not a dict, or missing the 'user' key). Must not crash."""
    raise NotImplementedError("safe_get_user")


def summary(events):
    """Return exactly: '<N> events; top user: <user>'  (N = valid entries only).
    Build it from your earlier functions."""
    raise NotImplementedError("summary")


if __name__ == "__main__":
    print(count_by_type(events))                    # {'login': 4, 'edit': 3, 'logout': 3}
    print(len(events_in_window(events, 100, 250)))  # 5
    print(top_user(events))                         # ana
    print(safe_get_user(events[7]))                 # None
    print(summary(events))                          # 10 events; top user: ana
`

export const TASK1_TASK2_STARTER = `import trio
import time
import httpx
import os
import requests
import pandas as pd

############## TASK 1 ###################
async def timer() -> None: 
    """Prints the number of seconds that have passed starting at '1s' """
    raise NotImplementedError("timer") 

async def delayed_hello() -> None: 
    """Sleeps for 2.1 seconds and the prints 'Hello, World!' """
    raise NotImplementedError("delayed_hello")  

async def task1():
    """
    In this task, you will use the trio library to write two async functions. 
    Your task is to complete the timer and delayed_hello functions. 
    """
    print("Starting...")
    TIMEOUT = 2.5
    with trio.move_on_after(TIMEOUT): 
        # TODO: start trio nursery
        # TODO: start timer function
        # TODO: start delayed_hello
        pass 
    print("Completed!")
    return 

############## END TASK 1 ###################


############## TASK 2 #######################
async def get_user_id(user_id: int) -> str:
    await trio.sleep(1)
    if user_id % 2 == 0: 
        return f"User-{user_id}"
    else: 
        raise ValueError(f"User {user_id} not found")

async def get_user_data(user_ids: list[int]) -> dict[str]:
    """
    Asynchronously fetch user_ids using get_user_id. Store the result as 'error' if 
    an error is encountered. 
    """
    raise NotImplementedError("Implement get_user_data") 
    
    
async def task2(): 
    """
    In this task, you will implement error handling . In this test case, we create a list of 5 user IDs (mix of even and odd numbers). We call get_user_data() with this list. 
    """
    user_ids = [1, 2, 3, 4, 5]
    results= await get_user_data(user_ids)
    print("Results:") 
    for user_id, result in results.items(): 
        print(f"User {user_id}: {result}")

############## END TASK 2 ###################
`

export const A1B1_INSTRUCTIONS_MD = `# Asynchronous Programming with Trio 



## Task 1: Concurrent Execution
**Setup**: To begin make sure you run: \`\`\`pip install trio\`\`\` in the terminal.  
### Introduction to Trio

Trio is a Python library designed for asynchronous programming. It provides a structured and easy-to-use approach to handling concurrency. Trio is particularly known for its focus on simplicity and correctness, making it a great choice for developers who want to write reliable asynchronous code without getting bogged down by the complexities often associated with concurrency.

One of the core features of Trio is its use of "nurseries", which allow you to manage multiple **concurrent** asynchronous tasks. For example, consider the following usage of a nursery in Trio:
\`\`\`python
async def parent():
    print("parent: started!")
    async with trio.open_nursery() as nursery: # asynchronous context manager 
        print("parent: spawning child1...")
        nursery.start_soon(child1) # schedules child1 to run concurrently
        
        print("parent: spawning child2...") # this prints immediately
        nursery.start_soon(child2) # schedules child2 to run concurrently

        print("parent: waiting ...") # this also prints immediately
        # The nursery waits here until ALL child tasks complete

    print("parent: all done!") # prints only after both children finish
 
trio.run(parent) #runs a Trio async function
\`\`\`
The code above demonstrates concurrent execution using Trio's structured concurrency model. Some key points:

- \`trio.open_nursery()\` creates a asynchronous context for managing concurrent tasks (must use \`async with\` to create)
- \`nursery.start_soon(...)\` schedules functions to run concurrently but doesn't wait for them to complete (this function returns \`None\`)
- The parent function continues executing immediately after each \`start_soon()\` call
- Only when exiting the nursery context (the \`async with\` block) does the parent wait for all children to complete

#### Trio's \`sleep\` Function

In asynchronous programming, it's common to introduce delays or pauses in the execution of tasks. Trio provides the \`trio.sleep()\` function to achieve this. The \`trio.sleep()\` function takes a single argument, the number of seconds to sleep, and is used with the \`await\` keyword. For example:  
\`\`\`python
async def child1():
    print("child1: starting")
    await trio.sleep(2)  # pauses child1 here for 2 seconds
    print("child1: done") 

async def child2():
    print("child2: starting") 
    await trio.sleep(1)  # pauses child2 here for 1 second
    print("child2: done")
\`\`\`
When \`await trio.sleep(2)\` is encountered, \`child1\` pauses its execution for 2 seconds, but \`child2\` (running concurrently in the nursery) can continue executing during this time. This is why you might see "child2: done" print before "child1: done" even though child1 started first. Together, they only take 2 seconds to complete when running concurrently. 

### Task 1: Beginner Async Functions

Implement the missing code in the \`timer\`, \`delayed_hello\`, and \`task1\` functions to create a concurrent program.

- \`timer\`:  This function prints how many seconds have passed every second and uses \`trio.sleep\` to wait between prints. This function should never return and always keep a count of seconds. 
- \`delayed_hello\`: This function waits for 2.1 seconds and then after the delay, prints "Hello, World!"
- \`task1\`: This function starts a nursery context and calls the \`timer\` and then the \`delayed_hello\` function.  

Once you've completed these three functions, you can compare your code to the expected output. For this task none of the functions return any values, they simply print statements. Make sure you run: \`\`\`pip install trio\`\`\` in the terminal before you test out your trio code. 

**Expected Output**: 
\`\`\`
Starting...
1s 
2s
Hello, World!
Completed!
\`\`\`

## Task 2: Error Handling in Async Code

**Setup**: To begin make sure you run: \`\`\`pip install trio\`\`\` in the terminal.  

When using async libraries such as Trio, proper error handling is crucial to ensure that if one task fails, the other tasks can continue running independently. In asynchronous programming, multiple tasks often run concurrently, and an unhandled exception in one task can potentially cause the entire group of tasks to fail or terminate early if not managed correctly. To prevent this, you can use try/except blocks inside each async task. This way, you can catch and handle exceptions locally, record the error, and allow the rest of the tasks to continue running. This approach leads to more robust and fault-tolerant async programs.

In this task, you will practice error handling in async functions by implementing the following:
- \`get_user_data\`: This function should implement a helper function \`_fetch_and_store\` that uses a try/except block to call \`get_user_id(user_id)\`. If the call is successful, it stores the result in a results dictionary; if an exception occurs, it stores the string \`'error'\` for that user ID. The function should return the results dictionary. For example:
  - \`get_user_data([2, 3, 4])\` returns \`{2: 'User-2', 3: 'error', 4: 'User-4'}\`

Here is an example of how \`get_user_data\` will be called: 
\`\`\`python
async def task2(): 
    user_ids = [1, 2, 3, 4, 5]
    results= await get_user_data(user_ids)
    print("Results:") 
    for user_id, result in results.items(): 
        print(f"User {user_id}: {result}")
\`\`\`

**Expected Output**: Results can be in any order for this question.  
\`\`\`
Results:
User 5: 'error'
User 4: 'User-4'
User 3: 'error'
User 2: 'User-2'
User 1: 'error'
\`\`\`

**Hint:** If you encouter a \`Execution time limit exceeded\` error, you might not be fetching user ids asynchronously.
`

export const A2_TASK_MD = `# Task: System Startup Sequence
**Setup**: make sure \`trio\` is installed (\`pip install trio\`). **No AI tools and no outside help for this task.** The official Trio documentation link in the sidebar is available.

You're building the startup routine for a small service. Three provided functions are already implemented for you — **do not modify them**:

- \`load_config()\` — loads configuration (prints \`Loading config\`, takes 0.5s, prints \`Config loaded\`)
- \`worker(n)\` — worker \`n\` does its job (prints \`Worker {n} starting\`, runs \`n * 0.5\` seconds, prints \`Worker {n} done\`)
- *(you implement)* \`heartbeat()\` — see below

Implement the missing code in \`heartbeat\` and \`task_a2\`:

- \`heartbeat\`: prints \`tick\` every **0.4 seconds** (first tick after 0.4s), forever. It never returns on its own.
- \`task_a2\`: orchestrates startup with these rules:
  1. Print \`Booting...\` first.
  2. **Configuration must fully complete before anything else starts.**
  3. Then workers 1 and 2 run **at the same time**, with the heartbeat ticking alongside them.
  4. The worker phase is capped at **1.3 seconds** — when it ends, the heartbeat stops.
  5. Print \`Shutdown complete\` last, after the worker phase has ended.

Once you've completed both functions, run your code and compare against the expected output. None of the functions return values — they only print.

**Expected Output**:
\`\`\`
Booting...
Loading config
Config loaded
Worker 1 starting
Worker 2 starting
tick
Worker 1 done
tick
Worker 2 done
tick
Shutdown complete
\`\`\`

*(The two \`Worker … starting\` lines may appear in either order — every other line's position is fixed.)*

**Hint:** if lines appear in the wrong order, think carefully about *when* each function is allowed to start, not just which functions you call.
`

export const B2_TASK_MD = `# Task: Resilient Record Retrieval
**Setup**: make sure \`trio\` is installed (\`pip install trio\`). **No AI tools and no outside help for this task.** The official Trio documentation link in the sidebar is available.

You're fetching records from a flaky data service. The provided \`fetch_record\` function is already implemented — **do not modify it**. It can fail in two ways, and they must be handled differently:

- \`TransientError\` — a temporary glitch (a timeout). **Retrying the fetch once** usually resolves it.
- \`PermanentError\` — the record is corrupted. Retrying never helps.

Implement \`get_records\`:

- \`get_records(record_ids)\` fetches all the records **at the same time** and returns a dictionary mapping each id to its result:
  - success → the record string (e.g. \`'Record-2'\`)
  - \`TransientError\` → **retry once**; if the retry succeeds, store the record; if it fails again (either error), store \`'error'\`
  - \`PermanentError\` → store \`'error'\` immediately (no retry)

For example: \`get_records([2, 3, 4])\` returns \`{2: 'Record-2', 3: 'error', 4: 'Record-4'}\` *(4 succeeds on its retry)*.

Here is how \`get_records\` will be called:
\`\`\`python
async def task_b2():
    record_ids = [1, 2, 3, 4, 5, 6]
    results = await get_records(record_ids)
    print("Results:")
    for record_id, result in results.items():
        print(f"Record {record_id}: {result}")
\`\`\`

**Expected Output**: results can be in any order for this question.
\`\`\`
Results:
Record 1: Record-1
Record 2: Record-2
Record 3: error
Record 4: Record-4
Record 5: Record-5
Record 6: error
\`\`\`

**Hint:** if you see an \`Execution time limit exceeded\` error, you might not be fetching records concurrently. If the whole program crashes with a traceback, look at *which* errors your code catches.
`

export const WARMUP_TASK_MD = `# Warm-up — Event Log Summarizer
*Screening session · proctored · no AI, no outside resources · 15-minute box.*
*Replaces S&T's \`addBorder\` (see \`warmup_addborder_reference.md\` for why).*

## Participant-facing statement

You're given a list of event records from a small web app. Some entries may be corrupted. Implement the functions below **in order** — it's fine not to finish; do as much as you can in 15 minutes. Run the file at any point to check your work against the expected values shown at the bottom.

1. \`count_by_type(events)\` → dict mapping event type → count. Ignore corrupted entries.
2. \`events_in_window(events, start, end)\` → list of events with \`start <= ts < end\`. Ignore corrupted entries.
3. \`top_user(events)\` → the user with the most events; if there's a tie, the alphabetically first user.
4. \`safe_get_user(event)\` → the event's user string, or \`None\` if the entry is corrupted (not a dict, or missing the key) — without crashing.
5. *(if time remains)* \`summary(events)\` → the exact string \`"<N> events; top user: <user>"\`, where N counts valid entries only, built from your earlier functions.

Files: \`warmup_starter.py\` (work here) · \`warmup_solution.py\` (proctor reference — never shown).

## Design intent (internal)
Parts are ordered easy→hard so weak passers stall mid-list and strong passers finish — the covariate needs spread, not a floor. The corrupted entry makes exception handling load-bearing; the tie makes spec-reading load-bearing. S&T precedent for the covariate use: they controlled for warm-up *time* (d = 0.725 after adjustment); the checklist is a richer version of the same move.

## Concept checklist rubric (coded from the screening recording, 0/1/2 each)

| Concept | 0 | 1 | 2 |
|---|---|---|---|
| Iteration | no working loop | loop works after visible trial-and-error | clean first-pass iteration |
| Conditionals | absent / wrong logic | works after debugging | correct incl. boundary (\`<\` vs \`<=\`) |
| Dict/list operations | can't build the dict | builds with fumbling (KeyError → fix) | idiomatic (\`.get\` / \`setdefault\` / clean equivalent) |
| Functions & returns | prints instead of returning / signature confusion | returns correctly after correction | clean signatures and returns throughout |
| Exception handling | no attempt at #4 / crashes | try/except that over-catches | targeted handling, returns \`None\` correctly |
| Tie-breaking / spec reading | ignores the tie rule | notices late, patches | alphabetical tie handled first pass |
| Composition | not reached | partial \`summary\` | working \`summary\` |

**Composite:** sum, 0–14. **Eligibility gate (lenient floor):** ≥3 total with ≥1 in Iteration AND ≥1 in Functions — "can write a loop inside a function." Everything above the gate is covariate variance.
**Coding protocol:** scored by the research team from the screening recordings after the call (not live), against the checklist above — each cell is a verifiable, objective criterion.
`

export const INSTRUCTION_SCREENS_MD = `# Instruction Screens
*Participant-facing text shown before each block, S&T-style (their Figs. 23–24 were exactly this: a short screen with the AI-use rule bolded). All block-level decisions settled 2026-07-20 under the fidelity-to-S&T rule — this text is freeze-ready; think-alouds may adjust wording only.*

---

## S0 · Screening — before the warm-up (proctor reads + on-screen)

> **Warm-up exercise — 15 minutes.**
> This is a short Python exercise so we can see how you work. **No AI tools and no outside resources** — just you and the editor. Work top to bottom; it's completely fine not to finish. You can run the file at any time to check your work. Talk through your thinking or stay quiet, whichever you prefer. I'll be here but won't help beyond clarifying the instructions.

---

## M0 · Main session — welcome screen

> **Welcome back. This session takes about 80–90 minutes and runs in timed blocks:**
> 1. Short concept quiz *(no AI)*
> 2. Two learning tasks with an **AI tutor available** *(20 minutes each)*
> 3. A few quick questions
> 4. One programming task *(no AI)*
> 5. Short quiz *(no AI)* and a final survey
>
> Before you start: confirm your **Zoom recording is running**, you are sharing your **entire screen**, and your **camera is on**. Each block has its own timer — when it ends, the platform moves you forward automatically. You can't return to earlier blocks. The official Trio documentation link in the sidebar is available throughout.

*(Platform gate: cannot advance past M0 until the acknowledgment checkbox is ticked: "My screen share and camera are on.")*

---

## M1 · Before the concept quiz

> **Concept quiz — about 5 minutes, no AI, no outside resources.**
> A few short questions about programming concepts. This is a baseline, not a test you can fail — answer with your best guess, and use "I'm not sure" freely. Your answers don't affect your payment.

---

## M2 · Before each learning task (A1 / B1) — AI available

> **Learning task — 20 minutes. The AI tutor is available for this task.**
> You'll learn a Python library called **Trio** by completing a task. The instructions on the left include a short tutorial with examples — the task can be completed from what's on this page.
> **Try to complete the task as quickly as you can.** The AI tutor is here to help you do that — ask it questions, request code, paste errors, whatever gets you to a working solution fastest. The expected output is shown in the instructions; run your code as often as you like to check against it.

*(Settled — S&T speed instruction replicated. Their instruction went to all participants, and their own data shows the behavioral variance survives it: six usage patterns, 24–86% quiz range. Time pressure with AI available is also the output-incentive condition the thesis studies.)*

*(The second task's screen adds one line: "This task is standalone — everything you need is in its instructions. A fresh AI-tutor conversation starts here." Chat resets between tasks — settled, matching S&T's per-task reset.)*

---

## M3 · Before the mid-session questions

> **A few quick questions (1 minute).** No right answers — we're interested in how things feel at this point.

---

## M4 · Before the transfer task — no AI

> **Programming task — no AI for this one.**
> This task is done **entirely on your own: no AI tools, no web search, no notes from elsewhere, no other people.** The official Trio documentation link in the sidebar remains available. You can run your code as often as you like.
> This part is what the study is really measuring, and the recording is how we keep it fair for everyone — thank you for playing it straight.
> ☐ **I understand this task is to be completed without AI or outside help.** *(must check to proceed)*

*(Settled — docs allowed during coding blocks, matching S&T: both their conditions could reference documentation during tasks. The quiz stays closed, also matching them. Same rule holds at the probe.)*

---

## M5 · Before the quiz

> **Short quiz — about 15 minutes, no AI, no outside resources.** The documentation link is disabled for this block — it is a knowledge check.
> A few questions about how Trio works. The quiz is split across pages and **you can't go back to earlier pages**, so answer each page before moving on. Guessing is fine; blank answers can't be scored. Your payment doesn't depend on your score.

---

## M6 · Before the exit survey

> **Last step — a short survey (3–4 minutes).** One question asks whether you used any outside help during the no-AI parts. **Your answer does not affect your payment** — it only helps us interpret the data, and honest answers genuinely help the research.

*(After submit: the probe-booking gate — "Pick your 20-minute follow-up slot, 6–8 days from now. The [$10–15] bonus is attached to completing it." Session cannot close unbooked.)*

---

## P0 · Probe session — welcome (day 6–8)

> **Welcome back — about 20 minutes today.**
> Same setup as last time: join the Zoom link, share your **entire screen**, **camera on**. Today: one quick question, one programming task, and two wrap-up questions.
> **The task is no-AI, same rules as before:** no AI tools, no web search, no notes, no other people; the official Trio docs link is available. Your **[$10–15]** bonus is paid on completion — it does not depend on how you do.
> ☐ **My recording is on, and I understand today's task is completed without AI or outside help.**

---

## Notes for the port
- Every screen is one page, one scroll max — S&T's were terse and so are these.
- Framing, docs access, and chat reset are settled under the fidelity rule (2026-07-20). No unfrozen text remains; everything can go into think-alouds as-is.
- The M4/P0 pledge checkboxes are S&T's pledge (their Figs. 21–22) folded into the instruction screen rather than a separate page.
- Timers, block gating, and the M0/M6 platform gates are engineering items from the needs map.
`
